exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-content-half .el-form-item__content{max-width:50%}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/AuditInternEditForm.vue"],"names":[],"mappings":"AACA,0CAA0C,aAAa,CACtD","file":"AuditInternEditForm.vue","sourcesContent":["\n.form-content-half .el-form-item__content{max-width:50%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52ceffca","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/audit-intern/pages/AuditInternEditForm.vue
// module id = 3201
// module chunks = 125